import Repository from "./Repository";

const resource = "/test";

export default {
    // get(){
    //     return Repository.get(`${resource}`);
    // },
    post(payload){
        return Repository.post(`${resource}`,payload);
    },
    get(payload){
        return Repository.get(`${resource}/${payload.testId}?user=${payload.user}`);
    },
    put(payload){
        // console.log(payload)
        return Repository.post(`${resource}/${payload.id}`,payload);

    }
}